// // Replace Buy it now button text
// function replaceBuyNowText() {
//   const buyNowButtons = document.querySelectorAll('.shopify-payment-button__button--unbranded');
  
//   buyNowButtons.forEach(button => {
//     if (button && !button.dataset.textReplaced) {
//       button.textContent = ' 🛒 Order Now - COD / Prepaid';
//       button.dataset.textReplaced = 'true';
//     }
//   });
// }

// // Run on page load
// document.addEventListener('DOMContentLoaded', replaceBuyNowText);

// // Run after dynamic content loads
// setTimeout(replaceBuyNowText, 500);
// setTimeout(replaceBuyNowText, 1000);

// Replace Buy it now button text
function replaceBuyNowText() {
  const buyNowButtons = document.querySelectorAll('.shopify-payment-button__button--unbranded');
  
  buyNowButtons.forEach(button => {
    if (button && !button.dataset.textReplaced) {
      button.textContent = ' 🛒 Order Now - COD / Prepaid';
      button.dataset.textReplaced = 'true';
    }
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', replaceBuyNowText);

// Run after dynamic content loads
setTimeout(replaceBuyNowText, 500);
setTimeout(replaceBuyNowText, 1000);

// Watch for cart drawer/popup opening
const observer = new MutationObserver(function(mutations) {
  replaceBuyNowText();
});

// Start observing the document for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Also run when cart is updated
document.addEventListener('cart:updated', replaceBuyNowText);
